export default __webpack_public_path__ + "static/Get-Phonesmart-Graphic-x2-4078e2df7fa7746e2c1c784b8e595560.png";